const UPDATES = [
  {
    date: '2026.07.29',
    tag: '新站收录',
    title: '新增3个优质韩漫漫画网站入口，覆盖恋爱与奇幻题材',
  },
  {
    date: '2026.07.28',
    tag: '专题更新',
    title: '韩漫之家暑期追更专题上线，精选50部热门连载韩漫',
  },
  {
    date: '2026.07.27',
    tag: '榜单更新',
    title: '韩漫人气榜单本周刷新，《秘密关系》蝉联热度榜首',
  },
  {
    date: '2026.07.26',
    tag: '平台维护',
    title: '韩漫导航平台完成架构升级，页面访问速度提升30%',
  },
  {
    date: '2026.07.25',
    tag: '内容更新',
    title: '韩漫屋平台大量上新，新增悬疑与古风题材韩漫入口',
  },
  {
    date: '2026.07.24',
    tag: '用户反馈',
    title: '根据漫迷建议优化韩漫网址分类导航，浏览体验更流畅',
  },
  {
    date: '2026.07.23',
    tag: '新站收录',
    title: '收录韩漫吧等新锐韩漫网站，免费韩漫在线观看入口扩充',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            更新动态
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            韩漫导航平台与各大韩漫网站的最新动态与快讯
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {UPDATES.map((item, i) => (
            <div
              key={i}
              className={`relative flex gap-4 pb-6 ${
                i < UPDATES.length - 1
                  ? 'border-l-2 border-background-200 ml-[7px] pl-6'
                  : 'ml-[7px] pl-6'
              }`}
            >
              <div className="absolute -left-[7px] top-0 w-4 h-4 rounded-full bg-accent-500 border-2 border-background-100 flex-shrink-0"></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className="text-xs bg-primary-100 text-primary-600 px-2 py-0.5 rounded-full font-medium">
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  {item.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}